export default {"src":"https://cdn2.e-farm.com/website-static/_next/static/media/cs.0cc3da02.svg","height":480,"width":640,"blurWidth":0,"blurHeight":0};